import { render, staticRenderFns } from "./LmUserPermissions.vue?vue&type=template&id=6958b86a&"
import script from "./LmUserPermissions.vue?vue&type=script&lang=js&"
export * from "./LmUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports